<template>
<div style="margin:0 auto;width: 960px;background: #fff;height: 100%" >
  <div id="relatedTransactionsWrapper" class="mb-2">
    <div class="card mt-4">
                        <div class="card-header">
                            <div class="card-title">
                                <h4>트랜잭션 흐름</h4>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <table class="table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9">
                                <thead>
                                    <tr>
                                        <th>번호</th>
                                        <th >관련 번호</th>
                                        <th width="100">타입</th>
                                       <th  width="100">변동전 </th>
                                        <th width="100">변동 금액</th>
                                        <th  width="100">변동후 </th>
                                        <th  width="100">처리 시각</th>
                                        <th width="100">행위</th>
                                    </tr>
                                </thead>
                                <tbody>
                            <tr  v-for="(item,index) in orders" :key="index" :index="index">
                                <td>{{formatTxid(item.txid)}}</td>
                                <td>{{item.round_id}}</td>
                                <td>{{item.tx_type}}</td>
                               <td>{{formatMoney(item.balance)}}</td>
                                 <td>{{item.bet!="0" ? formatMoney(item.bet):formatMoney(item.win)}}</td>
                                <td>{{formatMoney(item.after)}}</td>
                                <td>{{item.create_at}}</td>
                                <td>{{txtypeObj[item.tx_type]}}</td>
                            </tr>
                        
                        </tbody>
                            </table>
                        </div>
                    </div>
    </div>
        <div id="userBettingWrapper" class="mb-2">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                <h4>유저 베팅</h4>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <table class="table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9" id="userBetsTable">
                                <thead>
                                    <tr>
                                        <th>베팅픽</th>
                                    
                                        <th>베팅 금액</th>
                                        <th>당첨 금액</th>
                                        <th>베팅 시각</th>
                                    </tr>
                                </thead>
                                <tbody><tr v-for="(item,index) in bets" :key="index" :index="index">
                                  <td>{{item.code}}</td><td>{{formatMoney(item.stake)}}</td><td>{{formatMoney(item.payout)}}</td><td>{{item.placedOn}}</td></tr></tbody>
                            </table>
                        </div>
                    </div>
                </div>

             <tbody class="text-center">

  <!-- ✅ Lightning Roulette：解析显示 -->
  <template v-if="isRouletteResult">

    <tr>
      <th>Winning Number</th>
      <td>
        <span
          class="result-badge"
          :class="'color-' + (result.outcomes[0].color || 'Black')"
        >
          {{ result.outcomes[0].number }}
        </span>
      </td>
    </tr>

    <tr>
      <th>Lucky Numbers</th>
      <td>
        <span
          v-for="(multi, num) in result.luckyNumbers"
          :key="num"
          style="
            display:inline-block;
            margin-right:8px;
            padding:4px 6px;
            border:1px solid #ddd;
            border-radius:4px;
          "
        >
          {{ num }} × {{ multi }}
        </span>
      </td>
    </tr>

  </template>

  <!-- ✅ 有 result，但不是 Roulette：Raw JSON -->
  <tr v-else-if="hasResult">
    <th>Result (Raw)</th>
    <td>
      <textarea
        readonly
        rows="6" cols="100"
        style="width:100%; font-size:12px;"
      >{{ formattedResult }}</textarea>
    </td>
  </tr>

  <!-- ✅ 完全没有 result -->
  <tr v-else>
    <td colspan="2" style="padding:10px">
      결과 없음
    </td>
  </tr>

</tbody>



                <div id="gameInfoWrapper" class="mb-2" style="">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                <h4>게임 정보</h4>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <table class="table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9">
                                <tbody>
                                    <tr>
                                        <th>소속 에이전트</th>
                                        <td><span id="detailsAgentName">{{agent}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>유저</th>
                                        <td><span id="detailsUser">{{mem_id}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>게임사</th>
                                        <td><span id="detailsProvider">{{gameProvider}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>딜러</th>
                                        <td><span id="detailsDealer">{{dealer.name}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>테이블</th>
                                        <td><span id="detailsTableName">{{table.name}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>시작 시각</th>
                                        <td><span id="detailsStartedAt">{{startedAt}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>마감 시각</th>
                                        <td><span id="detailsSettledAt">{{settledAt}}</span></td>
                                    </tr>
                                    <tr>
                                        <th>게임 상태</th>
                                        <td><span id="detailsStatus">{{status}}</span></td>
                                    </tr>
                                   <!--  <tr>
                                        <th>처리 시각</th>
                                        <td><span id="detailsProcessedAt">2023-05-26 01:18:39</span></td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
</div>
 </template>

 <script>
 
    export default {
   
       props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
       bets:{
        type:Array,
        default:()=>{
          return {}
        }
      },
      
      gameProvider:{
        type:String,
        default:""
      },
     mem_id:{
        type:String,
        default:""
      },
      agent:{
        type:String,
        default:""
      },
       
       dealer:{
        type:Object,
        default:()=>{
          return {}
        }
      },
       table:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      
       orders:{
        type:Array,
        default:()=>[]
        
      },
     status:{
        type:String,
        default:""
      },
       settledAt:{
        type:String,
        default:""
      },
       startedAt:{
        type:String,
        default:""
      },
      result: {
  type: Object,
  default: function () {
    return {}
  }
},
    },
        data(){
            return{
                txtypeObj:{
                    'bet':'베팅',
                    'win':'당첨금',
                },
                domain:window.sessionStorage.getItem('domain'),
          power:window.sessionStorage.getItem('power'),
            
                   
                     
                }
                
                
            },
            created() {
        
          console.log('id',this.info.id)
         
    },
        
        methods:{
          formatTxid(txid) {
            const value = txid === undefined || txid === null ? '' : String(txid)
            const memberId = this.mem_id === undefined || this.mem_id === null ? '' : String(this.mem_id)

            if (!memberId || value.indexOf(memberId) === -1) {
              return value
            }

            return value
              .split(memberId)
              .join('')
              .replace(/^[-_:.\s]+|[-_:.\s]+$/g, '')
          },
        },
        computed: {
             
             hasResult() {
    return this.result && Object.keys(this.result).length > 0
  },

  isRouletteResult() {
    return this.result &&
      Array.isArray(this.result.outcomes) &&
      this.result.outcomes.length > 0 &&
      this.result.outcomes[0].number !== undefined &&
      this.result.luckyNumbers &&
      typeof this.result.luckyNumbers === 'object' &&
      Object.keys(this.result.luckyNumbers).length > 0
  },

  formattedResult() {
    try {
      return JSON.stringify(this.result, null, 2)
    } catch (e) {
      return ''
    }
  }
},
  }
</script>

 <style scoped>
.card-body{
  padding:0;
}
  #gameResultWrapper img {
    width: 100px;
    border:1px solid #333;border-radius:5px;
    margin-right: 10px;}
  .card {
    font-size: 14px;
    border: 1px dashed #e8e5dd;
    box-shadow: none;
    position: relative;
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    background-color: rgba(248,246,242,.3);
    background-clip: border-box;
    border-radius: 0.95rem;
}
.card .card-header {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
    min-height: 70px;
    padding: 0 2.25rem;
    background-color: transparent;
    border-bottom: 1px dashed #e8e5dd
}

.card .card-header .card-title {
    display: flex;
    align-items: center;
    margin: .5rem;
    margin-left: 0
}
.card .card-header .card-title h4{font-size: 18px;color: #211f1c;font-weight: bold;}
.card .card-header .card-title.flex-column {
    align-items: flex-start;
    justify-content: center
}

.table.gs-9 td:first-child,.table.gs-9 th:first-child {
    padding-left: 2.25rem
}

.table.gs-9 td:last-child,.table.gs-9 th:last-child {
    padding-right: 2.25rem
}

.table.gs-9 td.dtr-control:first-child,.table.gs-9 th.dtr-control:first-child {
    padding-left: 2.25rem!important
}
.table.gs-9 td{
    word-break: break-all;
}
.result-badge {
  display: inline-block;
  min-width: 36px;
  padding: 6px 10px;
  border-radius: 6px;
  color: #fff;
  font-weight: bold;
  text-align: center;
}

/* Roulette 标准颜色 */
.color-Red {
  background-color: #c0392b;
}

.color-Black {
  background-color: #2c2c2c;
}

.color-Green {
  background-color: #1e8449;
}
</style>



// WEBPACK FOOTER //
// src/components/common/holdem.vue